import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

import ButtonContained from '$app-web/components/button-contained';

import useStyles, { LoadingProgress } from './styles';

interface Props {
    className?: string;
    variant?: 'loading' | 'error' | 'error-with-button';
    errorText?: string;
    errorButtonText?: string;
    onErrorButtonClick?: () => void;
    showErrorText?: boolean;
}

const LoadingBar = ({
    className,
    variant = 'loading',
    errorText,
    showErrorText = true,
    errorButtonText = '',
    onErrorButtonClick,
}: Props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={clsx(classes.root, className)}>
            {variant === 'loading' && <LoadingProgress className={classes.loading} />}
            {(variant === 'error' || variant === 'error-with-button') && (
                <>
                    {showErrorText && (
                        <Typography variant="body2" color="error">
                            {errorText || t('generic_error_msg')}
                        </Typography>
                    )}
                    {variant === 'error-with-button' &&
                        (onErrorButtonClick ? (
                            <ButtonContained
                                text={errorButtonText}
                                color="error"
                                handleClick={onErrorButtonClick}
                                className={classes.button}
                            />
                        ) : (
                            <ButtonContained
                                text={t('refresh') as string}
                                color="error"
                                className={classes.button}
                                // @ts-expect-error: `component` is not supported by ButtonContained for TypeScript
                                component="a"
                                href={window.location.href}
                            />
                        ))}
                </>
            )}
        </div>
    );
};

export default LoadingBar;
